import axiosInstance from './axiosInstance';

export async function signIn(user) {
  try {
    const url = `auth/v2-sign-in`;

    let data, loggedInLocale;

    try {
      //First we try to login with en-US locale
      ({ data } = await axiosInstance.post(url, {
        ...user,
        admin: true
      }, {
        headers: {
          'Accept-Language': 'en-US'
        }
      }));
      loggedInLocale = 'en-US';
    }
    catch(e) {
      // If we get an unauthorized admin access error, we try again with en-GB locale
      if(e?.response?.data?.detail === 'Unauthorized: Admin access required') {
        ({ data } = await axiosInstance.post(url, {
          ...user,
          admin: true
        }, {
          headers: {
            'Accept-Language': 'en-GB'
          }
        }));
        loggedInLocale = 'en-GB';
      }
      else {
        // If the error is something else, we rethrow it
        throw e;
      }
    }

    data.profile.loggedInLocale = loggedInLocale;

    localStorage.setItem('access_token', data.tokens.accessToken);
    localStorage.setItem('refresh_token', data.tokens.refreshToken);
    localStorage.setItem('kinship_web_profile', JSON.stringify(data.profile));

    return data.profile;

  } catch (e) {
    console.log('[debug] signIn - Cannot signin', e, e?.response?.data);
    throw new Error(e?.response?.data?.detail || 'Invalid email or password');
  }
}

export async function refreshUserAccessToken() {
  try {
    const url = `auth/v2-refresh-token`;

    const refreshToken = localStorage.getItem('refresh_token');

    const { data } = await axiosInstance.post(url, { refreshToken });

    localStorage.setItem('access_token', data.accessToken);

  } catch (e) {
    console.log('[debug] refreshUserAccessToken - Cannot refresh access token', e);
    throw new Error('refreshUserAccessToken - Cannot refresh access token', e);
  }
}